import { isFunction, isArray, merge } from 'lodash'

export function setLegendMoreMap (series, option, legendMoreMapConfig = {}) {
  const legendMoreMap = merge({
    isOpen: false,
    top: 0,
    right: 0,
    width: 40,
    show: false,
    margin: 24, // 间距
    label: '更多',
    visibleNum: 5,
    data: [],
    filterData: [],
    searchValue: '',
    placeholder: '请输入指标名称',
    poppverProps: {
      width: 152 - 8 * 2, // 16是上下左右的间距, css中的 padding: 8px
      trigger: 'click',
      popperClass: 'kye-report-echarts-legend-more-poppver',
      popperClassContentStyle: {
        height: '229px'
      }
    }
  }, legendMoreMapConfig)
  const { width, margin, visibleNum, visibleNames = [] } = legendMoreMap
  const isExitVisibleNames = !!visibleNames.length
  const visibleLength = visibleNames.length || visibleNum
  const legendData = []
  const legendDataInNames = []
  const { selected, data } = series.reduce((acc, {name, type}, index) => {
    const checked = visibleNames.length ? visibleNames.includes(name) : index < visibleNum
    const isBar = type === 'bar'
    const legendDataItem = Object.assign({name}, isBar ? {icon: 'circle'} : {})
    legendData.push(legendDataItem)
    if (isExitVisibleNames && visibleNames.includes(name)) {
      legendDataInNames.push(legendDataItem)
    }
    acc.data.push({
      name,
      checked
    })
    acc.selected[name] = checked
    return acc
  }, {
    selected: {},
    data: []
  })
  option.legend.data = isExitVisibleNames ? legendDataInNames : legendData.slice(0, visibleLength)
  if (series.length <= visibleLength || !option) {
    return legendMoreMap
  }
  option.legend.right += width + margin
  option.legend.selected = selected
  const { right, top, padding } = option.legend
  legendMoreMap.right = right - width * 1.5
  legendMoreMap.top = top + padding
  legendMoreMap.show = true
  legendMoreMap.data = data
  return {
    legendMoreMap
  }
}

export const extend = Object.assign

export function tooltipTitleRender ({name = ''} = {}) {
  return name ? `<div class="kye-report-form__tooltip__title">${name}</div>` : ''
}

function tooltipTransformParam (c, v, _v, p) {
  return c && !v ? _v : (isFunction(v) ? v(p) : (v || ''))
}

function fixedMarkerSize (val, legend) {
  try {
    const { itemHeight = 8 } = legend || {}
    // 使用正则表达式替换
    return String(val).replace(/(border-radius:)\d+px;/, `$1${itemHeight}px;`).replace(/(width:)\d+px;/, `$1${itemHeight}px;`).replace(/(height:)\d+px;/, `$1${itemHeight}px;`)
  } catch (error) {
    return val
  }
}

export function tooltipContentRender (data, params, legend) {
  const {
    value: _value,
    marker: _marker,
    seriesName: _seriesName
  } = data || {}
  const {
    showMarker = true,
    marker,

    showSeriesName = true,
    seriesName,

    showValue = true,
    value
  } = params || {}

  const _params = {
    data,
    params
  }

  const obj = {
    markerContent: tooltipTransformParam(showMarker, marker, fixedMarkerSize(_marker, legend), _params),
    seriesNameContent: tooltipTransformParam(showSeriesName, seriesName, _seriesName, _params),
    valueContent: tooltipTransformParam(showValue, value, _value, _params),
  }
  const addDivWrap = (val) => val ? `<div>${val}</div>` : ''
  return Object.keys(obj).reduce((res, k) => {
    res[k] = addDivWrap(obj[k])
    return res
  }, {})
}

function tooltipFormatterWrapItem (val, params, legend) {
  const _params = {
    data: val,
    params
  }
  const {
    useBaseContent = true,
    content
  } = params || {}

  const _contentRender = tooltipContentRender(val, params, legend)
  const _content = tooltipTransformParam(useBaseContent, _contentRender, content, _params)
  return _content
}

export function tooltipFormatterWrap (val, params, legend) {
  const {
    useBaseTitle = true,
    title,
  } = params || {}
  const _params = {
    data: val,
    params,
  }
  const _title = tooltipTitleRender(isArray(val) ? val[0] : val)
  const _titleContent = tooltipTransformParam(useBaseTitle, title, _title, _params)
  const content = {
    markerContentList: [],
    seriesNameContentList: [],
    valueContentList: []
  }
  const render = isArray(val) ? val.reduce((acc, v) => {
    const {
      markerContent,
      seriesNameContent,
      valueContent
    } = tooltipFormatterWrapItem(v, params, legend)
    if (markerContent) {
      acc.markerContentList.push(markerContent)
    }
    if (seriesNameContent) {
      acc.seriesNameContentList.push(seriesNameContent)
    }
    if (valueContent) {
      acc.valueContentList.push(valueContent)
    }
    return acc
  }, content) : content

  const markerContentHtml = render.markerContentList.join('')
  const seriesNameContentHtml = render.seriesNameContentList.join('')
  const valueContentHtml = render.valueContentList.join('')
  return `<div style="box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);">
    ${_titleContent}
    <div class="kye-report-form__tooltip__item">
      ${markerContentHtml ? `<div class="kye-report-form__tooltip__item__marker">${markerContentHtml}</div>` : ''}
      ${seriesNameContentHtml ? `<div class="kye-report-form__tooltip__item__seriesName">${seriesNameContentHtml}</div>` : ''}
      ${valueContentHtml ? `<div class="kye-report-form__tooltip__item__value">${valueContentHtml}</div>` : ''}
    </div>
  </div>`
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/common/utils.js